import { useSelector } from 'react-redux'
import { useParams } from 'react-router'

import { RootState } from '../../../redux/store'
import { Snippet } from '../../../services/models/Snippet.model'
import { SnippetDetail } from './SnippetDetail'

export const Snippets = () => {
    const {abbreviation} = useParams()
    const {snippets} = useSelector((state:RootState)=> state.snippets)
    
    const snippet = snippets.find((snippet: Snippet)=> snippet.abbreviation === abbreviation)
    
    return (
        <div className="p-5 w-full h-full">
            <SnippetDetail snippet={snippet} />
        </div>
    )
}
